import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '../shared/Button.svelte';
import Card from '../shared/Card.svelte';
import { showToast } from '../shared/Toast.svelte';

var root_4 = $.from_html(`<div class="note-item svelte-219bftsgewkzv"><span class="note-text svelte-219bftsgewkzv"> </span> <div class="note-right svelte-219bftsgewkzv"><span class="note-time svelte-219bftsgewkzv"> </span> <button class="delete-note svelte-219bftsgewkzv" aria-label="Delete note">×</button></div></div>`);
var root_3 = $.from_html(`<div class="notes-list svelte-219bftsgewkzv"></div>`);
var root_1 = $.from_html(`<div class="handoff svelte-219bftsgewkzv"><h3 class="svelte-219bftsgewkzv">Handoff Note</h3> <p class="hint svelte-219bftsgewkzv">Leave a note for your partner or caregiver. Notes are saved on this device.</p> <textarea placeholder="e.g. Baby last ate at 2pm, seemed fussy" rows="2" class="svelte-219bftsgewkzv"></textarea> <!> <!></div>`);

function HandoffNote($$anchor, $$props) {
	$.push($$props, true);

	const STORAGE_KEY = 'mamaobaby-handoff-notes';
	let note = $.state('');
	let savedNotes = $.state($.proxy(JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')));

	function handleSave() {
		if (!$.get(note).trim()) return;

		$.set(
			savedNotes,
			[
				{ text: $.get(note), time: Date.now() },
				...$.get(savedNotes)
			],
			true
		);

		localStorage.setItem(STORAGE_KEY, JSON.stringify($.get(savedNotes)));
		$.set(note, '');
		showToast('Note saved', 'success');
	}

	function handleDelete(index) {
		$.set(savedNotes, $.get(savedNotes).filter((_, i) => i !== index), true);
		localStorage.setItem(STORAGE_KEY, JSON.stringify($.get(savedNotes)));
	}

	function formatTime(ts) {
		return new Date(ts).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
	}

	var fragment = $.comment();
	var node = $.first_child(fragment);

	Card(node, {
		padding: 'md',
		children: ($$anchor, $$slotProps) => {
			var div = root_1();
			var textarea = $.sibling($.child(div), 4);

			$.remove_textarea_child(textarea);

			var node_1 = $.sibling(textarea, 2);

			{
				let $0 = $.derived(() => !$.get(note).trim());

				Button(node_1, {
					variant: 'secondary',
					size: 'sm',
					onclick: handleSave,
					get disabled() {
						return $.get($0);
					},

					children: ($$anchor, $$slotProps) => {
						$.next();

						var text = $.text('Save Note');

						$.append($$anchor, text);
					},
					$$slots: { default: true }
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent = ($$anchor) => {
					var div_1 = root_3();

					$.each(div_1, 21, () => $.get(savedNotes), $.index, ($$anchor, n, i) => {
						var div_2 = root_4();
						var span = $.child(div_2);
						var text_1 = $.child(span, true);

						$.reset(span);

						var div_3 = $.sibling(span, 2);
						var span_1 = $.child(div_3);
						var text_2 = $.child(span_1, true);

						$.reset(span_1);

						var button = $.sibling(span_1, 2);

						$.reset(div_3);
						$.reset(div_2);

						$.template_effect(
							($0) => {
								$.set_text(text_1, $.get(n).text);
								$.set_text(text_2, $0);
							},
							[() => formatTime($.get(n).time)]
						);

						$.delegated('click', button, () => handleDelete(i));
						$.append($$anchor, div_2);
					});

					$.reset(div_1);
					$.append($$anchor, div_1);
				};

				$.if(node_2, ($$render) => {
					if ($.get(savedNotes).length > 0) $$render(consequent);
				});
			}

			$.reset(div);
			$.bind_value(textarea, () => $.get(note), ($$value) => $.set(note, $$value));
			$.append($$anchor, div);
		},
		$$slots: { default: true }
	});

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	HandoffNote = $.hmr(HandoffNote);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-219bftsgewkzv');
		HandoffNote[$.HMR].update(module.default);
	});
}

export default HandoffNote;

$.delegate(['click']);
import "bun-svelte:HandoffNote.svelte-333bs4kv2rr7i-style.css";